import { Navigate } from 'react-router-dom';
import { LoginForm } from '@/components/login-form';
import { useCognitoAuth } from '@/hooks/useCognitoAuth';

const LoginPage = () => {
  const { isAuthenticated, isLoading } = useCognitoAuth();

  // Redirect if already authenticated
  if (!isLoading && isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-[calc(100vh-3.5rem)] w-full items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <LoginForm />
      </div>
    </div>
  );
};

export { LoginPage };
